import produce from 'immer';
import {
  setSelectedEquipment,
  getLocationEquipments,
  setSelectedLocation,
} from './actions';

/* eslint-disable default-case */

const initialState = {
  loading: false,
  error: null,
  items: [],
  selectedEquipment: null,
  selectedLocation: null,
};

const reducer = produce((draft, { type, payload }) => {
  switch (type) {
    case getLocationEquipments.REQUEST:
      draft.loading = true;
      break;
    case getLocationEquipments.SUCCESS:
      draft.items = payload;
      break;
    case getLocationEquipments.FAILURE:
      draft.error = payload;
      break;
    case getLocationEquipments.FULFILL:
      draft.loading = false;
      break;
    case setSelectedEquipment.toString():
      draft.selectedEquipment = payload;
      break;
    case setSelectedLocation.toString():
      draft.selectedLocation = payload;
      break;
    // no default
  }
}, initialState);

export default reducer;
